declare global {
  interface Window {
    BtApp: {
      paymentFinished: (code: string | number, msg: string) => void;
      paymentStatus: (statusMessage: string) => void;
    };
    BtDevice: {
      getPaymentProviderLogo: () => string | undefined;
      getAuthorizationToken: () => string;
      startPayment: (amount: number) => void;
      cashPayment: (amount: number) => void;
      clearSettings: () => void;
    };
  }
}

// Store payment callbacks
let paymentStatusCallback: ((status: string) => void) | null = null;
let paymentFinishedCallback: ((code: number, msg: string) => void) | null = null;

export const setPaymentCallbacks = (
  onStatus: (status: string) => void,
  onFinished: (code: number, msg: string) => void
) => {
  paymentStatusCallback = onStatus;
  paymentFinishedCallback = onFinished;
};

export const clearPaymentCallbacks = () => {
  paymentStatusCallback = null;
  paymentFinishedCallback = null;
};

export const initializeBtInterfaces = () => {
  window.BtApp = {
    paymentFinished: (code: string | number, msg: string) => {
      console.log('[APP] paymentFinished', code, msg);
      
      const numericCode = typeof code === 'string' ? parseInt(code, 10) : code;
      
      // Call the registered callback if it exists
      if (paymentFinishedCallback) {
        paymentFinishedCallback(numericCode, msg);
      }
      
      // Handle payment completion
      if (numericCode !== 0) {
        // Payment failed
        console.error('Payment failed:', msg);
      } else {
        // Payment successful
        console.log('Payment successful');
      }
    },
    
    paymentStatus: (statusMessage: string) => {
      console.log('[APP] Payment status:', statusMessage);
      
      // Call the registered callback if it exists
      if (paymentStatusCallback) {
        paymentStatusCallback(statusMessage);
      }
    }
  };

};